module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d2dreview-page"
  }, [_c('div', {
    staticClass: "rv-title"
  }, [_vm._v("Secure booking - only takes a few minutes!")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex rv-page-body align-start"
  }, [_c('div', {
    staticClass: "rv-form"
  }, [_c('pax-form', {
    ref: "paxForm",
    staticClass: "pax-form-box",
    on: {
      "done": _vm.paxDone,
      "getCardsDone": _vm.getCardsDone
    }
  }), _vm._v(" "), (_vm.user.token || _vm.bookingAsGuest) ? _c('payment-form', {
    ref: "paymentForm",
    staticClass: "payment-form-box",
    on: {
      "done": _vm.paymentDone,
      "changeCard": _vm.changeCard
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user.token || _vm.bookingAsGuest) ? _c('div', {
    staticClass: "submit-box"
  }, [_c('div', {
    staticClass: "sb-header"
  }, [_vm._v("Review and book your trip")]), _vm._v(" "), _c('div', {
    staticClass: "sb-text"
  }, [_vm._v("1 . Review your trip details to make sure the dates and times are correct.")]), _vm._v(" "), _c('div', {
    staticClass: "sb-text"
  }, [_vm._v("2. Check your spelling. Flight passenger names must match government-issued photo ID exactly.")]), _vm._v(" "), _c('div', {
    staticClass: "sb-text"
  }, [_vm._v("3. Review the terms of your booking:")]), _vm._v(" "), _vm._m(0)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ps-box"
  }, [_c('payment-summary', {
    ref: "paymentSummary",
    attrs: {
      "notop": true
    }
  }), _vm._v(" "), _c('div', {
    class: ['lr-btn complete-btn', {
      highlight: _vm.card > 0
    }],
    on: {
      "click": _vm.validateForms
    }
  }, [_vm._v("\n        Confirm Booking\n        "), _c('i', {
    staticClass: "fas fa-chevron-right"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("\n            If you book a fare that allows changes, the airline may charge a change or cancel fee, plus any \n            fare difference. Airlines set change and cancel policies and fee amounts. We may collect these \n            change or cancel fees, which are then passed on to the airline.\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n            Your itinerary consists of two one-way fares which are subject to their own rules and restrictions. \n            If one of your flights is changed or cancelled, it will not automatically change the other flight. \n            You may incur a penalty fee for each flight for additional itinerary changes.\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n            In case of a no-show or cancellation, you may be entitled to a refund of airport taxes and fees \n            included in the price\n          ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-119023b0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-119023b0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/D2DReview/index.vue
// module id = 2036
// module chunks = 0